import { useMutation } from "@tanstack/react-query";

// Empty string means use current origin (for proxied setup), undefined means use localhost
const API_URL = import.meta.env.VITE_API_URL !== undefined
  ? import.meta.env.VITE_API_URL
  : "http://localhost:3000";

export interface CheckEmailResult {
  exists: boolean;
  hasPassword: boolean;
}

export function useCheckEmail() {
  return useMutation<CheckEmailResult, Error, { email: string }>({
    mutationFn: async ({ email }) => {
      const response = await fetch(`${API_URL}/api/auth/check-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ email }),
      });
      if (!response.ok) throw new Error("Unable to check email");
      return response.json();
    },
  });
}
